import { LFlex } from "@components";
import { NavItems } from "@helpers/navigation";
import { useNavigate } from "react-router";

export const PricingInfo = ({ maximumQuantity }: PricingInfoProps): JSX.Element => {
    const navigate = useNavigate();

    const handlerOnGo = (): void => {
        navigate(NavItems.Signup.ContactSales.path);
    };

    return (
        <LFlex alignCenter justifyCenter className="has-text-ldark-gray mt-5">
            <p className="is-size-4 has-text-weight-semibold">LASSI-D™ Assessments & Reports Pricing</p>
            <p className="mt-4">We offer tiered pricing based on the quantity you purchase.</p>
            <p className="has-text-weight-semibold">
                Need more than {maximumQuantity} assessments?{" "}
                <a className="has-text-weight-bold" onClick={handlerOnGo}>
                    Contact sales
                </a>
            </p>
        </LFlex>
    );
};

interface PricingInfoProps {
    maximumQuantity?: number;
}
